'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  placeholder: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative'
  },
  img: {
    width: '100%',
    height: 'auto',
    maxWidth: '100%',
    /* TODO: fix bug in styles */
    marginBottom: '-4px'
  },
  icon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center'
  },
  noscript: {
    position: 'absolute',
    top: 0,
    left: 0
  }
};


// WEBPACK FOOTER //
// ./node_modules/react-ideal-image/dist/components/theme.js